import ReportCreationPage from '@/pages/ReportCreationPage/ReportCreationPage.vue'

export default ReportCreationPage
